import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '../TooltipNew'
import values from 'lodash/values'
import { triggerClickOnEnter, ACCESSIBILITY_CLASSES, TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

export const TYPES = {
  classic: 'classic',
  icon: 'icon'
}

export const CHECKBOX_THEMES = {
  default: 'default',
  themeColor: 'theme-color',
  themeColorBold: 'theme-color theme-bold',
  green: 'green'
}

export const CHECKBOX_SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large'
}

const STATE_SIGNES = {
  checked: 'icon-tick-sign',
  indeterminate: 'indeterminate',
  unchecked: ''
}

export default function Checkbox(props) {
  const handleClick = (e) => {
    e.stopPropagation()

    if (props.disabled) {
      return
    }

    props.onClick && props.onClick(e)
  }

  const classNames = {
    checked: props.checked ? 'checked' : '',
    disabled: props.disabled ? 'disabled' : '',
    theme: props.theme,
    className: props.className,
    indeterminate: props.indeterminate ? 'indeterminate' : '',
    size: props.size
  }

  let sign = STATE_SIGNES.unchecked

  if (props.checked) {
    sign = STATE_SIGNES.checked
  } else if (props.indeterminate) {
    sign = STATE_SIGNES.indeterminate
  }

  return (
    <div
      className={`flz-checkbox ${values(classNames).join(' ')} `}
      onClick={handleClick}
      onKeyDown={triggerClickOnEnter}
      role="checkbox"
      aria-checked={!!props.checked}>
      <div className="checkbox-wrapper">
        <span className={`checkbox-box ${ACCESSIBILITY_CLASSES.main}`} tabIndex={TAB_INDEXES.CheckBox}>
          <span
            className={props.type === TYPES.icon ? props.iconButtonClass : sign}
            style={{ color: props.checkmarkColor }} />
        </span>
        <span className={props.iconClass} />
        { !!props.imgUrl && <img src={props.imgUrl} /> }
        { props.showTooltip
          ? (
            <Tooltip text={props.tooltip || props.label}>
              <label>{props.label}</label>
            </Tooltip>
            )
          : (
            <label>{props.label}</label>
            )}
      </div>
      {props.subLabel && <span className='sub-label'>{props.subLabel}</span>}
    </div>
  )
}

Checkbox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  subLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconClass: PropTypes.string,
  imgUrl: PropTypes.string,
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  checkmarkColor: PropTypes.string,
  disabled: PropTypes.bool,
  showTooltip: PropTypes.bool,
  tooltip: PropTypes.string,
  theme: PropTypes.oneOf(values(CHECKBOX_THEMES)),
  indeterminate: PropTypes.bool,
  size: PropTypes.oneOf(values(CHECKBOX_SIZES)),
  type: PropTypes.oneOf(values(TYPES)),
  iconButtonClass: PropTypes.string
}

Checkbox.defaultProps = {
  className: '',
  disabled: false,
  checked: false,
  showTooltip: false,
  theme: CHECKBOX_THEMES.default,
  size: CHECKBOX_SIZES.small,
  type: TYPES.classic
}
